import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

Vue.use(Vuex)

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

const moduleAuth = {
  state: {
    isAuthenticated: localStorage.getItem('isAuthenticated') == 'true',
  },
  getters: {
    isAuthenticated: state => {
      return state.isAuthenticated
    }
  },
  actions: {
    login( context, credentials) {
      return new Promise((resolve, reject) => {
        axios.post('/Auth/login', 
          {
            email: credentials.email,
            password: credentials.password
          },
        )
        .then(response => {
          localStorage.setItem('isAuthenticated', true)
          localStorage.setItem('userId', response.data.data.user_id)
          resolve(response)
        })
        .catch(error => {
          localStorage.setItem('isAuthenticated', false)
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-unused-vars
    checkLogin(context) {
      return new Promise((resolve, reject) => {
        axios.get('/Auth/check_login', {}, { withCredentials: true })
        .then(response => {
          resolve(response)
          console.log(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },

    // eslint-disable-next-line no-unused-vars
    logout({ commit }) {
      return new Promise((resolve, reject) => {

        localStorage.removeItem('isAuthenticated')
        localStorage.removeItem('userID')

        commit('setCurrentProcess', null)
        commit('setCars', [])
        
        axios.get('/Auth/logout', {}, { withCredentials: true })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
  }
}

const moduleDoc = {
  state: {
    documents: [],
    cars: [],
    parts: [],
  },
  getters: {
    getCars: state => {
      return state.cars
    },
    getCarById: (state) => (id) => {
      return state.cars.find(car => car.car_id === id)
    }
  },
  mutations: {
    // SET_DOCUMENTS(state, documentList) {
    //   documentList.forEach(element => {
    //     console.log(element)
    //     switch (element.document_type_id) {
    //       case "1":
    //         state.cars.push({
    //           data_id: element.data_id, 
    //           document_type_id: element.document_type_id, 
    //           data_doc_raw: element.data_doc_raw
    //         })
    //         break;
    //       case "2":
    //         state.parts.push({
    //           data_id: element.data_id, 
    //           document_type_id: element.document_type_id, 
    //           data_doc_raw: element.data_doc_raw
    //         })
    //         break;
    //     }
    //   });
    // },
    setCars(state, cars) {
      state.cars = cars
    },
    // td 202207071131 added pushCars method to paginate CarsPage listing
    pushCars(state, cars) {
      console.log(state.cars.length)
      if (state.cars.length == 0){
        state.cars = cars;
      } else {
        state.cars = [...state.cars, ...cars]
      }
      console.log(state.cars.length);
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    retrieveDocuments(context) {
      return new Promise((resolve, reject) => {
        axios.get('/Documents/get', {}, { withCredentials: true })
        .then((response => {
          // context.commit('SET_DOCUMENTS', response.data.data);
          resolve(response.data.data)
        }))
        .catch(error => {
          reject(error)
        })
      })
    },
    retrieveCars({ commit }, params = {}) {
      let query = '?'

      if (Object.keys(params).length > 0) {
        for (const [key, value] of Object.entries(params)) {
          if (key == 'id') {
            query = '/' + value
          } else {
            if (query.endsWith('?')) {
              query += key + "=" + value
            } else {
              query += '&' + key + "=" + value
            }
          }
        }
      }

      let url = '/Cars/get' + (query == '?' ? '' : query)

      console.log('RetrieveCars Query', url)
      return new Promise((resolve, reject) => {
        axios.get(url, {}, { withCredentials: true })
        .then(response => {
          if (query == '?') {
            commit('setCars', response.data.data);
          } else {
            commit('pushCars', response.data.data);
          }

          resolve(response.data.data)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    uploadPicture(context, picture) {
      var formData = new FormData();
      formData.append('data_id', picture.data_id)
      formData.append('data_doc_raw', picture.data_doc_raw)
      formData.append('document_type_id', picture.document_type_id)

      return new Promise((resolve, reject) => {
        axios.post('/Documents/put', formData, {withCredentials: true})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
  },
}

const moduleProcess = {
  state: {
    // this will indicate which process user is currently on
    currentPID: null,
    // taskDefinitionKey of current process
    currentTDK: null,
    // information of current task
    currentTask: null,
    deployedProcessList: {}
  },
  getters: {
    getCurrentPID: state => {
      return state.currentPID
    },
    getCurrentTDK: state => {
      return state.currentTDK
    },
    getCurrentTask: state => {
      return state.currentTask
    },
    getDeployedProcessList: state => {
      return state.deployedProcessList
    }
  },
  mutations: {
    setCurrentTaskDefinitionKey (state, key) {
      state.currentTDK = key
    },
    setCurrentTask (state, task) {
      state.currentTask = task
    },
    setCurrentProcess (state, pid) {
      state.currentPID = pid
      if (pid === null) {
        state.currentTDK = null
        state.currentTaskType = null
        state.currentTaskName = null
      }
    },
    setDeployedProcessList (state, list_) {
      state.deployedProcessList = list_
    }
  },
  actions: {
    /**
     * call the API to start a BPM process by definition key and variables
     * it will also retrieve the process instance ID for further use
     * #105 modified retrieveProcessInstanceID start a process with variables
     * 
     * @property {string} key definition key
     * @property {array} variables process variables
     */

     startBPMProcess({commit}, [key, variables])
     {
      return new Promise((resolve, reject) => {
        console.log('startBPMProcess', variables)
        if (variables==null)
        {
          variables={};
        }
        axios.post(`/BPM/processDefinition/key/${key}/start`, variables, { withCredentials: true })
        .then(response => {
          let pid = null
          try {
            pid = response.data.data.id
          } catch(error) {
            reject(error)
          }

          commit('setCurrentProcess', pid)
          resolve(pid)
      })
        .catch(error => {
          reject(error)
        })
      })
     },

    /** 
     * call the API to start a BPM process with given definition key and retrieve process instance ID
     * POST /BPM/processDefinition/key/{key}/start
     * 
     * @property {string} key definition key
     */
    retrieveProcessInstanceID ({ commit }, key) {
      return new Promise((resolve, reject) => {
        axios.post(`/BPM/processDefinition/key/${key}/start`, {}, { withCredentials: true })
        .then(response => {
          let pid = null
          try {
            pid = response.data.data.id
          } catch(error) {
            reject(error)
          }

          commit('setCurrentProcess', pid)
          resolve(pid)
      })
        .catch(error => {
          reject(error)
        })
      })
    },
    /**
     * retrieve process's current task to decide which view UI has to show
     * GET /api/v1/Presentation/get/:id
     * 
     * @param {*} context 
     * @param {string} pid process instance id
     */
    retrieveTaskDefinitionKey ({ commit, getters }, pid) {
      return new Promise((resolve, reject) => {
        axios.get(`/Presentation/get/${pid}`, {}, { withCredentials: true })
        .then(response => {
          let task = null
          try {
            task = response.data
          } catch (error) {
            reject(error)
          }
          
          const cpid = getters.getCurrentPID
          if (cpid == pid) { // the process (pid) is still on progress
            const currentTask = getters.getCurrentTask
            const currentTaskID = currentTask?.id

            if (currentTaskID != task.id) {
              commit('setCurrentTask', task)
              commit('setCurrentTaskDefinitionKey', task.taskId)
            }
            resolve(task)
          } else { // the process has ended somehow so no need to update TDK
            reject("The process was already ended")
          }

        })
        .catch(error => {
          reject(error)
        })
      })
    },

    // eslint-disable-next-line no-unused-vars
    retrieveProcessDefinitionList ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/BPM/processDefinition/', {}, { withCredentials: true })
        .then(response => {
          let pList = {}
          try {
            response.data.data.forEach(element => {
              const key  = element.key
              const exists = key in pList
  
              if (!exists || (exists && (element.version > pList[key].version))) {
                pList[key] = {
                  "key": key,
                  "name": element.name,
                  "version": element.version,
                  "id": element.id
                } 
              }
            })

            commit('setDeployedProcessList', pList)
            resolve(pList)
          } catch(error) {
            reject(error)
          }
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-unused-vars
    completeTask(context, params) {
      return new Promise((resolve, reject) => {
        console.log("completeTask():", params)
        axios({
          method: 'post',
          url: `/BPM/task/${params.taskId}/complete`,
          data: ('variables' in params) ? params.variables : {},
          withCredentials: true
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    retrieveProcessVariables(context, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/BPM/processInstance/${id}/variables`, {}, { withCredentials: true })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    retrieveTaskVariables(context, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/BPM/task/${id}/variables`, {}, { withCredentials: true })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    }
  }
}

const moduleGeoLocation = {
  actions: {
    updateGeolocation(context, coords) {
      let formData = new FormData()

      formData.append('latitude', coords.latitude)
      formData.append('longitude', coords.longitude)

      if (coords.altitude)
        formData.append('altitude', coords.altitude)  

      if (coords.accuracy)  
        formData.append('accuracy', coords.accuracy)
      
      if (coords.altitudeAccuracy)
        formData.append('altitude_accuracy', coords.altitudeAccuracy)

      if (coords.heading)
        formData.append('heading', coords.heading)

      if (coords.speed)
        formData.append('speed', coords.speed)

      if (coords.timestamp)
        formData.append('timestamp', coords.timestamp)

      return new Promise((resolve, reject) => {
        axios.post('/User_GPS/put', formData, { withCredentials: true })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
  },
}

export default new Vuex.Store({
  modules: {
    auth: moduleAuth,
    document: moduleDoc,
    process: moduleProcess,
    geoLocation: moduleGeoLocation
  },
  state: {
    notificationVisible: false,
    notificationText: '',
    notificationInterval: 4000,
    feedbackDialogVisible: false,
  },
  getters: {
    notificationVisible: (state) => {
      return state.notificationVisible
    },
    notificationText: (state) => {
      return state.notificationText
    },
    notificationInterval: (state) => {
      return state.notificationInterval
    },
    feedbackDialogVisible: (state) => {
      return state.feedbackDialogVisible
    }
  },
  mutations: {
    setNotificationVisible: (state, visible) => {
      state.notificationVisible = visible
    },
    setNotificationText: (state, text) => {
      state.notificationText = text
    },
    setFeedbackDialogVisible: (state, visible) => {
      state.feedbackDialogVisible = visible
    },
    setNotificationInterval: (state, interval) => {
      state.notificationInterval = interval
    }
  },
  actions: {
    showNotification({ commit }, payload) {
      commit('setNotificationText', payload.text)
      commit('setNotificationVisible', true)
      commit('setNotificationInterval', payload.interval)
    },
    hideNotification({ commit }) {
      commit('setNotificationVisible', false)
      commit('setNotificationInterval', 4000)
    },
    showFeedbackDialog({ commit }) {
      commit('setFeedbackDialogVisible', true)
    },
    hideFeedbackDialog({ commit }) {
      commit('setFeedbackDialogVisible', false)
    }
  }
})
